import CbCheckboxGroup from './src/checkbox-group.vue';

CbCheckboxGroup.install = function(Vue) {
  Vue.component(CbCheckboxGroup.name, CbCheckboxGroup);
};

export default CbCheckboxGroup;
